import { render, staticRenderFns } from "./emrDoctorTable.vue?vue&type=template&id=49f4583c&scoped=true&"
import script from "./emrDoctorTable.vue?vue&type=script&lang=js&"
export * from "./emrDoctorTable.vue?vue&type=script&lang=js&"
import style0 from "./emrDoctorTable.vue?vue&type=style&index=0&id=49f4583c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f4583c",
  null
  
)

export default component.exports